import { t } from 'i18next'
import React from 'react'
import { DeviceStatusDashboardCard } from '@asad/ui'
import { useTranslation } from 'react-i18next'

import {
  formatDate,
  calculateDaysRemaining,
  generalStatusText,
  getInspectionStatusTextAndColor,
  statusBagdeVariant,
} from '@/utils/utils'
import { Device } from '@/api/profile.api'
import { DeviceStatusType } from './Dashboard'

export type RealTimeData = Array<{ type: string; value: any; createdAt?: string }>

type DeviceCardProps = {
  device: Device
  hasActiveBorder: boolean
  deviceStatus?: DeviceStatusType
}

const DeviceCardComponent = ({ device, deviceStatus, hasActiveBorder }: DeviceCardProps) => {
  const { i18n } = useTranslation()
  const { deviceTemplates } = device

  const currentLang = i18n.language
  const deviceTemplate =
    deviceTemplates?.find(({ language }) => language === currentLang.toUpperCase()) || deviceTemplates?.[0]

  const deviceStatusBadgeVariant = statusBagdeVariant(deviceStatus?.alertStatus)
  const deviceStatusText = generalStatusText(deviceStatus?.alertStatus)
  const labelText = deviceTemplate?.resourceLabel || ''

  const latestInspection = device.inspections?.[0]
  const daysUntilExpirationUdt = latestInspection ? calculateDaysRemaining(String(latestInspection.validityDate)) : null

  const { text: daysUntilExpirationUdtText, color: inspectionWarningColor } = getInspectionStatusTextAndColor(
    latestInspection,
    daysUntilExpirationUdt,
  )

  return (
    <DeviceStatusDashboardCard
      key={device?.id}
      deviceName={device.name}
      deviceSerialNumber={device?.serialNumber}
      deviceUdtNumber={device.udtNumber}
      deviceStatusText={deviceStatusText}
      deviceStatusBadgeVariant={deviceStatusBadgeVariant}
      workingStatusBadgeVariant={deviceStatus?.isWorking ? 'success' : 'darkGrey'}
      resursLabel={labelText}
      progress={deviceStatus?.resource || 0}
      {...(daysUntilExpirationUdtText && { daysUntilExpirationUdtText })}
      date={
        latestInspection?.inspectionDate
          ? `${t('common.inspectionDate')}: ${formatDate(String(latestInspection.inspectionDate))}`
          : t('common.noInspection')
      }
      inspectionWarningColor={inspectionWarningColor}
      hasActiveBorder={hasActiveBorder}
    />
  )
}

const areEqual = (prev: DeviceCardProps, next: DeviceCardProps) => {
  return (
    prev.device.id === next.device.id &&
    prev.hasActiveBorder === next.hasActiveBorder &&
    prev.deviceStatus?.alertStatus === next.deviceStatus?.alertStatus &&
    prev.deviceStatus?.isWorking === next.deviceStatus?.isWorking &&
    prev.deviceStatus?.resource === next.deviceStatus?.resource
  )
}

export default React.memo(DeviceCardComponent, areEqual)
